import { render, staticRenderFns } from "./btns-operate.vue?vue&type=template&id=22d60e9d"
import script from "./btns-operate.vue?vue&type=script&lang=js"
export * from "./btns-operate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports